import { render, staticRenderFns } from "./PopConfirm.vue?vue&type=template&id=6dfb7811&scoped=true"
import script from "./PopConfirm.vue?vue&type=script&lang=js"
export * from "./PopConfirm.vue?vue&type=script&lang=js"
import style0 from "./PopConfirm.vue?vue&type=style&index=0&id=6dfb7811&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfb7811",
  null
  
)

export default component.exports